__turbopack_context__.v({
  "view": "WindowViews-module-scss-module__qMeR9G__view",
  "view__bottom": "WindowViews-module-scss-module__qMeR9G__view__bottom",
  "view__left": "WindowViews-module-scss-module__qMeR9G__view__left",
  "view__right": "WindowViews-module-scss-module__qMeR9G__view__right",
  "view__top": "WindowViews-module-scss-module__qMeR9G__view__top",
});
